export default __webpack_public_path__ + "static/media/robotHand1.f074a2c0.png";